// Shared money formatter used across pages.
export const money = (n) =>
  n == null
    ? "—"
    : `$${Math.round(n).toLocaleString("en-US")}`;

export const moneyRange = (low, high) => `${money(low)}–${money(high)}`;
